const webServ = () => `${window.location.protocol}//${window.location.host}`;
export const connectUrl = ( tail: string ) => { return `${webServ()}${tail}`; }
